// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","h2":"App_h2__LIWza"};